function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//Shared:
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n"; //Services:

import { ContributionsApiService } from "./Services/ContributionsApiService";
import { UserService } from "./Services/UserService";
import { OAuthService } from "./Services/OAuthService";
import { CardBuilder } from "./Helpers/CardBuilder"; //Helpers:

import { MyContributionFormBuilder } from "./Helpers/MyContributionFormBuilder";
export var MppMyContributionStatement = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyContributionStatement, _ComponentBase);

  var _super = _createSuper(MppMyContributionStatement);

  function MppMyContributionStatement() {
    _classCallCheck(this, MppMyContributionStatement);

    return _super.call(this);
  }

  _createClass(MppMyContributionStatement, [{
    key: "getContributionsApiService",
    value: // istanbul ignore next
    function getContributionsApiService() {
      return new ContributionsApiService();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.LoadLabels();

              case 2:
                this._i18n = _context.sent;
                this.LoadAttributes(); // Services

                this._contributionsService = this.getContributionsApiService(); //View HTML:

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><h1 id="pageTitle">${this._i18n.pageTitle}</h1><div id="spinner"><i class="mppw-spinner"></i></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myContributionNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div id="myContributionsDiv" style="display: none;"><div id="myContributionsDataContainer" style="display: none;"></div><div id="myContributionFooter"><div class="mppw-row"><div class="mppw-col"><div class="mppw-left">${CardBuilder.BuildSubscriptionCheckbox('StatementMethod', false)} <span class="mpp-subscriptions--checkboxlabel">${this._i18n.goPaperlessMessage}</span></div></div><div class="mppw-col"><div class="mppw-right"><p id="myGivingWidgetLink" style="display: none;">${this._i18n.myGivingPageUrlMessage} <a href="${this.myGivingWidgetUrl}" class="text-decoration-none">${this._i18n.myGivingPageUrlLabel}</a></p></div></div></div></div></div><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div></div>` ;
                this.BindHtmlElements(); //Get Event

                this.ShowSpinner();
                _context.next = 10;
                return this._checkUserIsAuthenticated();

              case 10:
                this.BindEventListeners();
                this.HideSpinner();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // istanbul ignore next

  }, {
    key: "getUserIsAuthenticated",
    value: function getUserIsAuthenticated() {
      return this.UserIsAuthenticated();
    }
  }, {
    key: "_checkUserIsAuthenticated",
    value: function () {
      var _checkUserIsAuthenticated2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getUserIsAuthenticated();

              case 2:
                this._userIsAuthenticated = _context2.sent;

                if (!(this._userIsAuthenticated === true)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 6;
                return this.LoadMyContributionData()["catch"](function (e) {
                  return console.error(e);
                });

              case 6:
                this._contributionData = _context2.sent;
                this._userInfo = null;

                if (!(!!this._contributionData && !this.IsEmptyObject(this._contributionData.myContributionStatements))) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return this.RenderMyContributionStatements();

              case 11:
                this.RenderMyGivingUrl();
                _context2.next = 15;
                break;

              case 14:
                // Display Message
                this.SetMessage("warning", this._i18n.notAvailableMessage, false);

              case 15:
                _context2.next = 18;
                break;

              case 17:
                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _checkUserIsAuthenticated() {
        return _checkUserIsAuthenticated2.apply(this, arguments);
      }

      return _checkUserIsAuthenticated;
    }()
  }, {
    key: "LoadAttributes",
    value: function LoadAttributes() {
      this.myGivingWidgetUrl = this.getAttribute("mygivingwidgettargeturl");
    } // istanbul ignore next

  }, {
    key: "LoadMyContributionData",
    value: function () {
      var _LoadMyContributionData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._contributionsService.GetMyContributions();

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function LoadMyContributionData() {
        return _LoadMyContributionData.apply(this, arguments);
      }

      return LoadMyContributionData;
    }() // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppMyContributionStatement.WidgetDetails.tag);
    }
  }, {
    key: "LoadLabels",
    value: function () {
      var _LoadLabels = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context4.sent;
                _context4.next = 10;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context4.t0);
                }

                return _context4.abrupt("return");

              case 10:
                return _context4.abrupt("return", i18n);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 6]]);
      }));

      function LoadLabels() {
        return _LoadLabels.apply(this, arguments);
      }

      return LoadLabels;
    }() // istanbul ignore next

  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      this._$spinner = this._root.querySelector("#spinner");
      this._$myContributionsDiv = this._root.querySelector("#myContributionsDiv");
      this._$myContributionsDataContainer = this._root.querySelector("#myContributionsDataContainer");
      this._$myContributionFooter = this._root.querySelector("#myContributionFooter");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$statementMethodCheck = this._root.querySelector('#StatementMethod');
      this._$myGivingWidgetLink = this._root.querySelector("#myGivingWidgetLink");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$loginButton = this._root.querySelector("#loginButton");
      this._$pageTitle = this._root.querySelector("#pageTitle");
    }
  }, {
    key: "RenderMyContributionStatements",
    value: function () {
      var _RenderMyContributionStatements = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._$myContributionsDiv.style.display = "";
                this._$myContributionsDataContainer.style.display = "";
                this._$myContributionsDataContainer.innerHTML = ""; // Draw statements

                MyContributionFormBuilder.DrawForm(this._$myContributionsDataContainer, this._contributionData.myContributionStatements, this._i18n); // Set default checkbox value

                if (this._contributionData.donorStatmentMethodId == 2) {
                  this._$statementMethodCheck.checked = true;
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function RenderMyContributionStatements() {
        return _RenderMyContributionStatements.apply(this, arguments);
      }

      return RenderMyContributionStatements;
    }()
  }, {
    key: "RenderMyGivingUrl",
    value: function RenderMyGivingUrl() {
      if (!!this.myGivingWidgetUrl) {
        this._$myGivingWidgetLink.style.display = "";
      }
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this = this;

      this._$saveAsPdfButtons = this._root.querySelectorAll(".save-as-pdf");
      this._$statementYearButtons = this._root.querySelectorAll(".statement-year-button");

      this._$saveAsPdfButtons.forEach(function (el) {
        var element = el;
        element.addEventListener("click", function (event) {
          _this.DisplayPDF(element);
        });
      });

      this._$statementYearButtons.forEach(function (el) {
        var element = el;
        var accountingCompanyName = el.getAttribute("data-accounting-group");
        var fileUrl = el.getAttribute("data-file-url");

        if (!!accountingCompanyName) {
          element.addEventListener("click", function (event) {
            _this.SetSaveAsPDFUrl(accountingCompanyName, fileUrl);

            _this.SetStatementYearButtonActive(accountingCompanyName, element);
          });
        }
      });

      this._$statementMethodCheck.addEventListener('change', function (event) {
        _this.SetStatementMethod(event.target.checked);
      });
    }
  }, {
    key: "SetStatementMethod",
    value: function SetStatementMethod(goPaperless) {
      var _this2 = this;

      return this._contributionsService.SetStatementMethod(goPaperless).then(function (data) {
        _this2.SetMessage("success", _this2._i18n.statementMethodUpdated);
      })["catch"](function (error) {
        console.error(error);

        _this2.SetMessage("danger", _this2._i18n.statementMethodUpdateError, false);
      });
    }
  }, {
    key: "SetStatementYearButtonActive",
    value: function SetStatementYearButtonActive(accountingCompanyName, element) {
      // Remove all active classes for the accounting group labels found
      Array.from(this._root.querySelectorAll("[data-accounting-group-label=\"".concat(accountingCompanyName, "\"]"))).forEach(function (el) {
        el.classList.remove('active');
      }); // Set the active class to closest label, since the element is the input element

      element.closest('label').classList.add('active');
    }
  }, {
    key: "SetSaveAsPDFUrl",
    value: function SetSaveAsPDFUrl(accountingCompanyName, fileUrl) {
      // Find the correct pdf button and sets its data file url
      // The data-file-url will then be used to display the pdf
      var saveAsPDFButton = this._root.querySelector("[data-file-group=\"".concat(accountingCompanyName, "\"]"));

      saveAsPDFButton.setAttribute("data-file-url", fileUrl);
    }
  }, {
    key: "DisplayPDF",
    value: function DisplayPDF(element) {
      // Get pdf buttons data-file-url and display file
      var fileUrl = element.getAttribute("data-file-url");
      window.location.href = fileUrl;
    }
  }, {
    key: "UserIsAuthenticated",
    value: function () {
      var _UserIsAuthenticated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return UserService.GetCurrentUser();

              case 3:
                this._$loginButtonContainer.style.display = "none";
                this._$pageTitle.style.display = "";
                return _context6.abrupt("return", true);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);
                this._$loginButtonContainer.style.display = "";
                this._$pageTitle.style.display = "none";
                return _context6.abrupt("return", false);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 8]]);
      }));

      function UserIsAuthenticated() {
        return _UserIsAuthenticated.apply(this, arguments);
      }

      return UserIsAuthenticated;
    }()
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      var _this3 = this;

      var autoHideMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";

      if (autoHideMessage) {
        setTimeout(function () {
          _this3.HideMessage();
        }, 6000);
      }
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }, {
    key: "ShowSpinner",
    value: function ShowSpinner() {
      this._$spinner.style.display = "";
    }
  }, {
    key: "HideSpinner",
    value: function HideSpinner() {
      this._$spinner.style.display = "none";
    }
  }, {
    key: "IsEmptyObject",
    value: function IsEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Contribution Statements",
        tag: "mpp-my-contribution-statement",
        configurationItems: []
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["mygivingwidgettargeturl"];
    }
  }]);

  return MppMyContributionStatement;
}(ComponentBase);
MppMyContributionStatement.registerComponent(MppMyContributionStatement.WidgetDetails.tag, MppMyContributionStatement);